/* Configuración compartida: disponibilidad y precio verificados antes de añadir. */
window.OMBAComplementosConfigV3={
  "mx-deo": {
    "enabled": true,
    "context": "mx-deo-v3",
    "origin": "desodorante-corporal",
    "currency": "MXN",
    "locale": "es-MX",
    "parentVariantId": 45040380051507,
    "selectedCandidate": "gut",
    "candidates": {
      "gut": {
        "variantId": 45095351156787,
        "handle": "gut-health",
        "title": "OMBA Equilibrio Intestinal",
        "description": "Apoyo digestivo · Bienestar desde dentro",
        "quantity": 1,
        "unitPriceCents": 59900,
        "offerTotalCents": 59900,
        "status": "active",
        "needs": "Conexión del proveedor y coste real; venta bajo pedido autorizada",
        "cardTitle": "Súmale Equilibrio Intestinal",
        "cardDescription": "Apoyo digestivo · Bienestar desde dentro · 1 frasco",
        "fulfillmentMode": "supplier_connection_pending_sell_under_order",
        "inventoryPolicy": "continue"
      },
      "oxi": {
        "variantId": 45044237107251,
        "handle": "oxi-colon",
        "title": "OMBA Oxi-Colon · Limpieza intestinal",
        "description": "Limpieza intestinal · Apoyo al tránsito",
        "quantity": 2,
        "unitPriceCents": 64900,
        "offerTotalCents": 64900,
        "discountCode": "OXICOLON1X1",
        "status": "active",
        "needs": "Verificar combinación y margen; sin cambiar el precio vigente",
        "cardTitle": "Súmale Oxi-Colon · Limpieza intestinal",
        "cardDescription": "Apoyo al tránsito intestinal · Pack de 2 frascos",
        "expectedSku": "OMBA-OXI-120"
      }
    },
    "blockTitle": "Completa tu rutina de frescura",
    "activationMode": "public_availability_required",
    "fallbackMode": "manual_only",
    "physicalGiftsEnabled": false,
    "selectedCandidates": [
      "gut",
      "oxi"
    ]
  },
  "es-deo": {
    "enabled": true,
    "context": "es-deo-v3",
    "origin": "desodorante-corporal",
    "currency": "EUR",
    "locale": "es-ES",
    "parentVariantId": 67628455952566,
    "selectedCandidate": "mineral",
    "candidates": {
      "gut": {
        "variantId": 67663419146422,
        "handle": "gut-health",
        "title": "OMBA Equilibrio Intestinal",
        "description": "Apoyo digestivo · Bienestar desde dentro",
        "quantity": 1,
        "unitPriceCents": 2995,
        "offerTotalCents": 2995,
        "status": "active",
        "needs": "Conexión del proveedor y coste real; venta bajo pedido autorizada",
        "cardTitle": "Añade Equilibrio Intestinal",
        "cardDescription": "Apoyo digestivo · Bienestar desde dentro · 1 frasco",
        "fulfillmentMode": "supplier_connection_pending_sell_under_order",
        "inventoryPolicy": "continue"
      },
      "oxi": {
        "variantId": 67628469747894,
        "handle": "oxi-colon",
        "title": "OMBA Oxi-Colon · Limpieza intestinal",
        "description": "Limpieza intestinal · Apoyo al tránsito",
        "quantity": 2,
        "unitPriceCents": 3495,
        "offerTotalCents": 3495,
        "discountCode": "OXICOLON1X1",
        "status": "active",
        "needs": "Verificar combinación y margen; sin cambiar el precio vigente",
        "cardTitle": "Añade Oxi-Colon · Limpieza intestinal",
        "cardDescription": "Apoyo al tránsito intestinal · Pack de 2 frascos",
        "expectedSku": "OMBA-OXI-120"
      },
      "mineral": {
        "variantId": 67663491563702,
        "handle": "omba-pure",
        "title": "OMBA Frescura Mineral",
        "description": "Desodorante de alumbre en barra · Uso corporal",
        "quantity": 1,
        "unitPriceCents": 995,
        "offerTotalCents": 995,
        "status": "active",
        "expectedSku": "OMBA-PURE",
        "cardTitle": "Añade Frescura Mineral",
        "cardDescription": "Desodorante de alumbre en barra · Cuidado diario",
        "inventoryPolicy": "continue",
        "fulfillmentMode": "supplier_connection_pending_sell_under_order",
        "needs": "Coste entregado pendiente; no afirmar margen confirmado"
      }
    },
    "blockTitle": "Completa tu rutina de frescura",
    "activationMode": "public_availability_required",
    "fallbackMode": "manual_only",
    "physicalGiftsEnabled": false,
    "selectedCandidates": [
      "mineral",
      "gut",
      "oxi"
    ]
  },
  "mx-perimeno": {
    "enabled": true,
    "context": "mx-perimeno-v3",
    "origin": "perimeno",
    "currency": "MXN",
    "locale": "es-MX",
    "parentVariantId": 45044227899443,
    "selectedCandidate": "deseoFemenino",
    "candidates": {
      "deseoFemenino": {
        "variantId": 45098764664883,
        "handle": "omba-deseo-femenino",
        "title": "OMBA Deseo Femenino · Gomitas",
        "description": "60 gomitas con extracto de saw palmetto · Sabor frambuesa",
        "quantity": 1,
        "unitPriceCents": 59900,
        "offerTotalCents": 59900,
        "status": "active",
        "needs": "Conexión del proveedor y coste real; venta bajo pedido autorizada",
        "expectedSku": "OMBA-DESEO-FEM-GUM",
        "fulfillmentMode": "supplier_connection_pending_sell_under_order",
        "inventoryPolicy": "continue",
        "cardTitle": "Deseo Femenino",
        "cardDescription": "Libido y bienestar íntimo · 60 gomitas"
      }
    },
    "activationMode": "public_availability_required",
    "fallbackMode": "manual_only",
    "physicalGiftsEnabled": false,
    "selectedCandidates": [
      "deseoFemenino"
    ],
    "blockTitle": "Completa tu bienestar íntimo"
  },
  "mx-oxi": {
    "enabled": true,
    "context": "mx-oxi-v6",
    "origin": "oxi-colon",
    "currency": "MXN",
    "locale": "es-MX",
    "parentVariantId": 45044237107251,
    "selectedCandidate": "gut",
    "candidates": {
      "gut": {
        "variantId": 45095351156787,
        "handle": "gut-health",
        "title": "OMBA Equilibrio Intestinal",
        "description": "Apoyo digestivo · Bienestar desde dentro",
        "quantity": 1,
        "unitPriceCents": 59900,
        "offerTotalCents": 59900,
        "status": "active",
        "needs": "Conexión del proveedor y coste real; venta bajo pedido autorizada",
        "cardTitle": "Súmale Equilibrio Intestinal",
        "cardDescription": "Apoyo digestivo · Bienestar desde dentro · 1 frasco",
        "fulfillmentMode": "supplier_connection_pending_sell_under_order",
        "inventoryPolicy": "continue"
      }
    },
    "blockTitle": "Completa tu rutina digestiva",
    "activationMode": "public_availability_required",
    "fallbackMode": "manual_only",
    "physicalGiftsEnabled": false
  },
  "mx-nitrico": {
    "enabled": true,
    "context": "mx-nitrico-v6",
    "origin": "oxido-nitrico",
    "currency": "MXN",
    "locale": "es-MX",
    "parentVariantId": 45040629022771,
    "selectedCandidate": "prostate",
    "candidates": {
      "prostate": {
        "variantId": 45095351189555,
        "handle": "prostate-health",
        "title": "OMBA Cuidado Prostático",
        "cardTitle": "Súmale Cuidado Prostático",
        "description": "Bienestar masculino",
        "cardDescription": "Bienestar masculino · 1 frasco",
        "quantity": 1,
        "unitPriceCents": 59900,
        "offerTotalCents": 59900,
        "status": "active",
        "needs": "Conexión del proveedor y coste real; venta bajo pedido autorizada",
        "fulfillmentMode": "supplier_connection_pending_sell_under_order",
        "inventoryPolicy": "continue"
      }
    },
    "blockTitle": "Completa tu rutina de bienestar",
    "activationMode": "public_availability_required",
    "fallbackMode": "manual_only",
    "physicalGiftsEnabled": false
  },
  "es-oxi": {
    "enabled": true,
    "context": "es-oxi-v6",
    "origin": "oxi-colon",
    "currency": "EUR",
    "locale": "es-ES",
    "parentVariantId": 67628469747894,
    "selectedCandidate": "gut",
    "candidates": {
      "gut": {
        "variantId": 67663419146422,
        "handle": "gut-health",
        "title": "OMBA Equilibrio Intestinal",
        "description": "Apoyo digestivo · Bienestar desde dentro",
        "quantity": 1,
        "unitPriceCents": 2995,
        "offerTotalCents": 2995,
        "status": "active",
        "needs": "Conexión del proveedor y coste real; venta bajo pedido autorizada",
        "cardTitle": "Añade Equilibrio Intestinal",
        "cardDescription": "Apoyo digestivo · Bienestar desde dentro · 1 frasco",
        "fulfillmentMode": "supplier_connection_pending_sell_under_order",
        "inventoryPolicy": "continue"
      }
    },
    "blockTitle": "Completa tu rutina digestiva",
    "activationMode": "public_availability_required",
    "fallbackMode": "manual_only",
    "physicalGiftsEnabled": false
  },
  "es-nitrico": {
    "enabled": true,
    "context": "es-nitrico-v6",
    "origin": "oxido-nitrico",
    "currency": "EUR",
    "locale": "es-ES",
    "parentVariantId": 67628460703926,
    "selectedCandidate": "prostate",
    "candidates": {
      "prostate": {
        "variantId": 67663419179190,
        "handle": "prostate-health",
        "title": "OMBA Cuidado Prostático",
        "cardTitle": "Añade Cuidado Prostático",
        "description": "Bienestar masculino",
        "cardDescription": "Bienestar masculino · 1 frasco",
        "quantity": 1,
        "unitPriceCents": 2995,
        "offerTotalCents": 2995,
        "status": "active",
        "needs": "Conexión del proveedor y coste real; venta bajo pedido autorizada",
        "fulfillmentMode": "supplier_connection_pending_sell_under_order",
        "inventoryPolicy": "continue"
      }
    },
    "blockTitle": "Completa tu rutina de bienestar",
    "activationMode": "public_availability_required",
    "fallbackMode": "manual_only",
    "physicalGiftsEnabled": false
  },
  "es-perimeno": {
    "enabled": true,
    "context": "es-perimeno-v25",
    "origin": "perimeno",
    "currency": "EUR",
    "locale": "es-ES",
    "parentVariantId": 67628464636086,
    "selectedCandidate": "deseoFemenino",
    "candidates": {
      "deseoFemenino": {
        "variantId": 67684871602358,
        "handle": "omba-deseo-femenino",
        "title": "OMBA Deseo Femenino · Gomitas",
        "description": "60 gomitas con extracto de saw palmetto · Sabor frambuesa",
        "quantity": 1,
        "unitPriceCents": 2995,
        "offerTotalCents": 2995,
        "status": "active",
        "needs": "Conexión del proveedor y coste real; venta bajo pedido autorizada",
        "expectedSku": "OMBA-DESEO-FEM-GUM",
        "fulfillmentMode": "supplier_connection_pending_sell_under_order",
        "inventoryPolicy": "continue",
        "cardTitle": "Deseo Femenino",
        "cardDescription": "Libido y bienestar íntimo · 60 gomitas"
      }
    },
    "blockTitle": "Completa tu bienestar íntimo",
    "activationMode": "public_availability_required",
    "fallbackMode": "manual_only",
    "physicalGiftsEnabled": false,
    "selectedCandidates": [
      "deseoFemenino"
    ]
  }
};
